# Just a stub for now; should provide login and logout like $cordovaFacebook
@app.service 'facebookService', ->
  this